<script setup lang="ts">
import kultuuriminEst from "@/assets/kultuurimin_3lovi_est.svg";
import kultuuriminEng from "@/assets/kultuurimin_3lovi_eng_pms.svg";
import siseminEng from "@/assets/sisemin_3lovi_eng.png";
import siseminEst from "@/assets/sisemin_3lovi_est.png";
import {useI18n} from "vue-i18n";
import insa_icon from "@/assets/insa.png";
import logo_esf_eng from "@/assets/co_funded_by_eu_logo.svg";
import logo_eu_flag from "@/assets/amif.png";

const {t, locale} = useI18n();

const cultureMinPics = {
  EST: kultuuriminEst,
  ENG: kultuuriminEng,
  RUS: kultuuriminEst,
};

const interiorMinPics = {
  EST: siseminEst,
  ENG: siseminEng,
  RUS: siseminEst,
};

const props = withDefaults(defineProps<{
  showEsfLogo?: boolean;
  showInsaLogo?: boolean;
  showEuLogo?: boolean;
  showCultureMinLogo?: boolean;
  showInteriorMinLogo?: boolean;
}>(), {
  showEsfLogo: true,
  showInsaLogo: true,
  showEuLogo: false,
  showCultureMinLogo: true,
  showInteriorMinLogo: false,
});
</script>

<template>
  <div class="row logos-container">
    <div class="col-xl-4"/> <!-- spacer -->

    <div class="col-xl-8">
      <div class="row logos-row">
        <div class="col-lg-auto" v-if="props.showEsfLogo">
          <img alt="ESF logo" class="esf-logo" :src="logo_esf_eng"/>
        </div>

        <div class="col-lg-auto" v-if="props.showInsaLogo">
          <img alt="INSA logo" class="insa-logo" :src="insa_icon"/>
        </div>

        <div class="col-lg-auto" v-if="props.showEuLogo">
          <img alt="EU flag logo" class="eu-flag-logo" :src="logo_eu_flag"/>
        </div>

        <div class="col-lg-auto" v-if="props.showCultureMinLogo">
          <img alt="Ministry of Culture logo"
               class="culture-min-logo"
               :src="cultureMinPics[locale]"
          />
        </div>

        <div class="col-lg-auto" v-if="props.showInteriorMinLogo">
          <img alt="Ministry of the Interior logo"
               class="interior-min-logo"
               :src="interiorMinPics[locale]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.logos-container {
  margin-bottom: -6rem;
}

.logos-row {
  align-items: center;
  gap: 0.5rem;
}

.culture-min-logo {
  width: 288px;
  max-width: 100%;
}

.interior-min-logo {
  width: 288px;
  max-width: 100%;
}

.insa-logo {
  width: 129px;
  max-width: 100%;
  background: white;
}

.esf-logo {
  width: 181px;
  max-width: 100%;
  background: white;
}

.eu-flag-logo {
  width: 90px;
  max-width: 100%;
}
</style>
